/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.property.validation.rpc.PropertyValidationRpc
 */

export const evaluateProposedRulesRpc = {
  serviceName: 'com.hubspot.property.validation.rpc.PropertyValidationRpc',
  rpcName: 'evaluateProposedRules',
  auth: 'app',
  fingerprint: 'epLF2zrELJ8qwjCAXsdfVLY7wib7ViD4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const normalizeValueRpc = {
  serviceName: 'com.hubspot.property.validation.rpc.PropertyValidationRpc',
  rpcName: 'normalizeValue',
  auth: 'app',
  fingerprint: 'FYzgpUuBPKcqX3Gp778L6ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateDomainsRpc = {
  serviceName: 'com.hubspot.property.validation.rpc.PropertyValidationRpc',
  rpcName: 'validateDomains',
  auth: 'app',
  fingerprint: '6cnn_FBhNEue8D3cb1J-OpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const validateRegexRpc = {
  serviceName: 'com.hubspot.property.validation.rpc.PropertyValidationRpc',
  rpcName: 'validateRegex',
  auth: 'app',
  fingerprint: 'O60A3fh5THMk0gkGp92uQZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getValidationRulesByObjectTypeRpc = {
  serviceName: 'com.hubspot.property.validation.rpc.PropertyValidationRpc',
  rpcName: 'getValidationRulesByObjectType',
  auth: 'app',
  fingerprint: 'BYVSkF08hlolb7WQolzR8drHnIz_Tbd1',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};